<template>
  <div id="Trainresult">
    <div class="achieve">
      <div class="titletext">理论课成绩</div>
      <div v-if="!stuinfo.theory_score" class="noachieve">
        还没有成绩
        <br />等待实操
      </div>
      <div v-else class="haveachieve">
        <div class="textred">{{stuinfo.theory_score}}分</div>
        <div class="textred">{{stuinfo.practice_level}}</div>
      </div>
      <div></div>
    </div>
    <!-- <div class="achieve">
      <div class="titletext">实操课成绩</div>
      <div v-if="!stuinfo.practice_score" class="noachieve">
        还没有成绩
        <br />
        <br />等待实操
      </div>
      <div v-else class="haveachieve">
        <span class="textred">{{stuinfo.practice_score}}</span>分
      </div>

      <div></div>
    </div> -->
    <div class="achieve">
      <div class="titletext">灭火时间成绩</div>
      <div v-if="!stuinfo.fireout_level" class="noachieve">
        还没有成绩
        <br />
        <br />等待实操
      </div>
      <div v-else class="haveachieve">
        <div class="textred">{{stuinfo.outfire_time}}秒</div>
        <div class="textred">{{stuinfo.fireout_level | fireoutLevel}}</div>
      </div>
      <div></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Trainresult",
  props: ["stuinfo"],
  data() {
    return {};
  },
  filters:{
    fireoutLevel(value) {
      if (value == 'excellent') {
          return "优秀";
        } else if (value == 'good') {
          return "良好";
        } else if (value == 'normal') {
          return "普通";
        } else if (value == 'bad') {
          return "不合格";
        } else if (value == 'undefined') {
          return "未知";
        } else {
          return "未知";
        }
    }
  },
  methods: {},
};
</script>
<style scoped>
#Trainresult {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
@media screen and (max-width: 768px) {
.achieve {
  width: 30%;
  border: 1px solid red;
  height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  border-radius: 10px;
}
}
@media screen and (min-width: 768px) {
.achieve {
  width: 50%;
  border: 1px solid red;
  height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  border-radius: 10px;
  margin-right: 20px;
}
}
.achieve:first-of-type {
  background: #f9dfb6;
}
.achieve:nth-of-type(2) {
  background: #c6ddfa;
}
.achieve:nth-of-type(3) {
  background: #fbe1dd;
}
.titletext {
  font-size: 18px;
  font-weight: bold;
}
.noachieve {
  color: #666666;
}
@media screen and (max-width: 768px) {
.haveachieve {
  font-size: 20px;
}
}
@media screen and (min-width: 768px) {
.haveachieve {
  font-size: 25px;
}
}
.textred {
  color: red;
  font-weight: bold;
}
@media screen and (max-width: 768px){
  .titletext {
  font-size: 16px;
  /* font-weight: bold; */
}
.achieve {
  height: 25vh;
}
}
</style>


// WEBPACK FOOTER //
// src/components/Trainresult/Trainresult.vue